import localize from "../../../common/localize";
import { getOperationalStatusNameFromId } from "../../../common/utils";
import FieldValueItem from "../../../components/common/FieldValueItem";

export default function PreOrderSummary({ preOrder }) {
  const mustShowProductData = () =>
    (preOrder.ProductSerial && preOrder.ProductSerial?.length > 0) ||
    (preOrder.ProductModel && preOrder.ProductModel?.length > 0) ||
    (preOrder.BillNumber && preOrder.BillNumber?.length > 0) ||
    (preOrder.BillDate && preOrder.BillDate?.length > 0);

  return (
    <div style={{ width: "100%" }}>
      <p>
        <FieldValueItem fieldName={`* ${localize.general_information}`} />
        <FieldValueItem
          fieldName={`- ${localize.event_type}`}
          fieldValue={preOrder.ProductBrand?.Name ?? localize.no_data}
        />
        <FieldValueItem
          fieldName={`- ${localize.proceeding}`}
          fieldValue={preOrder.ProductType?.Name ?? localize.no_data}
        />
        <FieldValueItem
          fieldName={`- ${localize.status}`}
          fieldValue={
            preOrder.CurrentStatus
              ? preOrder.CurrentStatus.Name
              : preOrder.Event
              ? `${
                  preOrder.Event.CurrentStatus.Name
                } - ${getOperationalStatusNameFromId(
                  preOrder.Event.OperationalStatus
                )}`
              : localize.quotation_status_pending
          }
        />
        {preOrder.CurrentStatus && (
          <FieldValueItem
            fieldName={`- ${localize.status_observation}`}
            fieldValue={preOrder.StatusObservation}
          />
        )}
        {preOrder.Event && (
          <FieldValueItem
            fieldName={`- ${localize.order_code}`}
            fieldValue={preOrder.Event.Code}
          />
        )}
      </p>
      <br />
      <p>
        <FieldValueItem fieldName={`* ${localize.client_information}`} />
        <FieldValueItem
          fieldName={`- ${localize.identification_type}`}
          fieldValue={preOrder.ClientIdentificationType}
        />
        <FieldValueItem
          fieldName={`- ${localize.identification}`}
          fieldValue={preOrder.ClientIdentification}
        />
        <FieldValueItem
          fieldName={`- ${localize.client_name}`}
          fieldValue={preOrder.ClientName}
        />
        <FieldValueItem
          fieldName={`- ${localize.department}`}
          fieldValue={preOrder.State?.Name ?? localize.no_data}
        />
        <FieldValueItem
          fieldName={`- ${localize.city}`}
          fieldValue={preOrder.City?.Name ?? localize.no_data}
        />
        <FieldValueItem
          fieldName={`- ${localize.address}`}
          fieldValue={preOrder.ClientAddress}
        />
        <FieldValueItem
          fieldName={`- ${localize.phone_number}`}
          fieldValue={preOrder.ClientPhoneNumber}
        />
        <FieldValueItem
          fieldName={`- ${localize.email}`}
          fieldValue={
            preOrder.ClientEmail && preOrder.ClientEmail.length > 0
              ? preOrder.ClientEmail
              : localize.no_data
          }
        />
      </p>

      {mustShowProductData() && (
        <p>
          <br />
          <FieldValueItem fieldName={`* ${localize.product_data}`} />
          <FieldValueItem
            fieldName={`- ${localize.model}`}
            fieldValue={
              preOrder.ProductModel && preOrder.ProductModel.length > 0
                ? preOrder.ProductModel
                : localize.no_data
            }
          />
          <FieldValueItem
            fieldName={`- ${localize.serial}`}
            fieldValue={
              preOrder.ProductSerial && preOrder.ProductSerial.length > 0
                ? preOrder.ProductSerial
                : localize.no_data
            }
          />
          <FieldValueItem
            fieldName={`- ${localize.bill_number}`}
            fieldValue={
              preOrder.BillNumber && preOrder.BillNumber.length > 0
                ? preOrder.BillNumber
                : localize.no_data
            }
          />
          <FieldValueItem
            fieldName={`- ${localize.bill_date}`}
            fieldValue={
              preOrder.BillDate && preOrder.BillDate.length > 0
                ? preOrder.BillDate
                : localize.no_data
            }
          />
        </p>
      )}

      <p>
        <br />
        <FieldValueItem fieldName={`* ${localize.service_detail}`} />
        <FieldValueItem fieldValue={preOrder.Observation} />
      </p>
    </div>
  );
}
